module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: 'Fotovoltaico da Balcone',
      imgSrc: isMobile ? ['solutions_nav_stream_h5.webp', 'solutions_nav_stream_h5.jpg'] : ['solutions_nav_stream.webp', 'solutions_nav_stream.jpg'],
      detLink: "/".concat(locale, "/powerstream"),
      tag: 'New'
    }, {
      name: 'Abitazione mobile/off-grid',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }
    // {
    //     name: 'Components',
    //     icons: '',
    //     detLink: `https://${locale}.ecoflow.com/collections/power-kits-components`,
    // },
    // {
    //     name: 'Power Calculator',
    //     icons: '',
    //     detLink: `/${locale}/calculators/power-kits`,
    //     target: '_blank',
    // },
    ],

    content: {
      headerData: [{
        type: 'large',
        name: "Che cos'è l'impianto fotovoltaico da balcone PowerStream?",
        desc: 'Energia per giorno e notte. Risparmi intelligenti.',
        imgSrc: isMobile ? ['stream_bg_h5.webp', 'stream_bg_h5.jpg'] : ['stream_bg.webp', 'stream_bg.jpg'],
        detLink: "/".concat(locale, "/powerstream")
      }, {
        type: 'large',
        name: 'Power Kits per abitazione mobile/off-grid',
        desc: 'Semplici. Intelligenti. Compatti.',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series")
      }],
      contextList: [{
        type: 'small',
        name: 'Power Hub',
        desc: 'Hub di ingresso e uscita 5 in 1',
        imgSrc: isMobile ? ['solutions_list1_h5.webp', 'solutions_list1_h5.jpg'] : ['solutions_list1.webp', 'solutions_list1.jpg'],
        imgHoverSrc: ['solutions_list1_hover.webp', 'solutions_list1_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-kits-power-hub")
      }, {
        type: 'small',
        name: 'Batterie LFP',
        desc: 'Capacità di accumulo di 2-15kWh',
        imgSrc: isMobile ? ['solutions_list2_h5.webp', 'solutions_list2_h5.jpg'] : ['solutions_list2.webp', 'solutions_list2.jpg'],
        imgHoverSrc: ['solutions_list2_hover.webp', 'solutions_list2_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/lfp-battery")
      }, {
        type: 'small',
        name: 'Pannello di distribuzione CA/CC intelligente',
        desc: '6+12 circuiti CA/CC per i tuoi apparecchi',
        imgSrc: isMobile ? ['solutions_list3_h5.webp', 'solutions_list3_h5.jpg'] : ['solutions_list3.webp', 'solutions_list3.jpg'],
        imgHoverSrc: ['solutions_list3_hover.webp', 'solutions_list3_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/ac-dc-smart-distribution-panel")
      }, {
        type: 'small',
        name: 'Console di Power Kits',
        desc: 'Monta, monitora e controlla',
        imgSrc: isMobile ? ['solutions_list4_h5.webp', 'solutions_list4_h5.jpg'] : ['solutions_list4.webp', 'solutions_list4.jpg'],
        imgHoverSrc: ['solutions_list4_hover.webp', 'solutions_list4_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-kits-console")
      }]
    }
  };
};